// extracted by mini-css-extract-plugin
module.exports = {"main":"Main-module__main--2hSjA","noAuthorized":"Main-module__noAuthorized--3eI95"};